/* eslint-disable */
// @ts-nocheck
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core'
import { MasterKey } from '../../../models/master-key'

import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms'
import { MatAutocompleteTrigger } from '@angular/material/autocomplete'
import { MatSlideToggleChange } from '@angular/material/slide-toggle'
import { DealerMasterKeyService } from '@overtur-monorepo/keying-hierarchy'
import { DealerMasterKey, DealerMasterKeyRequest, Keyway, KeywayType } from '@overtur-monorepo/keying-shared'
import { Subject } from 'rxjs'
import { filter, takeUntil } from 'rxjs/operators'
import { KeywayService } from '../../../services/keyway-api/keyway.service'
import { ActiveTopMasterKeyService } from '../../../services/object-services/active-top-master-key.service'

@Component({
    selector: 'lib-dealer-masterkey-tree',
    templateUrl: './dealer-masterkey-tree.component.html',
    styleUrls: ['./dealer-masterkey-tree.component.scss'],
    standalone: false
})
export class DealerMasterKeyTreeComponent implements OnInit, OnDestroy, OnChanges {
  destroy$ = new Subject()

  showChangeKeys = true
  // masterKeyBitting = ''

  @Input() hierarchyItem: MasterKey
  @Input() structure
  @Input() keySystem
  @Input() lastChild = true
  @Input() keySections: Keyway[] = []
  @Input() dealerMasterKeys: DealerMasterKey[]

  @Output() patchItemAction = new EventEmitter<any>()
  @Output() dealererror = new EventEmitter<any>()
  @Output() isEditing = new EventEmitter<any>()

  @ViewChildren('inputRef') inputRefs: QueryList<any>

  editingCounter = 0

  @ViewChild('toggle') toggle: ElementRef
  isActiveTopMasterKey = false
  maxBittingLength: number

  childKeySections: Keyway[] = []
  dealerSpecs: DealerMasterKeyRequest[] = []
  saveAndContinueFormData: DealerMasterKeyRequest[] = []
  allDealerMasterKeys = []
  private keySectionLocallyModified = false

  initializingForm = false
  initialLoad = true

  form = new FormGroup({
    keySystemId: new FormControl(null),
    masterKeyId: new FormControl(null),
    isActiveTmk: new FormControl(null),
    keySection: new FormControl(null, [Validators.required]),
    keySectionId: new FormControl(null, [Validators.required]),
    masterKeyBitting: new FormControl(null, [
      Validators.required,
      Validators.pattern('[0-9]*'),
      Validators.maxLength(this.maxBittingLength),
    ]),
  })

  /* istanbul ignore next */
  get keySection(): AbstractControl {
    return this.form.get('keySection')
  }

  /* istanbul ignore next */
  get keySectionId(): AbstractControl {
    return this.form.get('keySectionId')
  }

  /* istanbul ignore next */
  get masterKeyBitting(): AbstractControl {
    return this.form.get('masterKeyBitting')
  }

  /* istanbul ignore next */
  get isActiveTmk(): AbstractControl {
    return this.form.get('isActiveTmk')
  }

  constructor(
    private keywayService: KeywayService,
    private dealerMasterKeyService: DealerMasterKeyService,
    private activeTopMasterKeyService: ActiveTopMasterKeyService
  ) {}

  /* istanbul ignore next */
  ngOnInit() {
    const ChamberTypes = {
      1: 5,
      2: 6,
      3: 7,
    }
    this.maxBittingLength = ChamberTypes[this.structure.chamberTypeId]

    this.activeTopMasterKeyService
      .getActiveTopMasterKey()
      .pipe(
        filter((activeTopMasterKey: number) => !!activeTopMasterKey),
        takeUntil(this.destroy$)
      )
      .subscribe((activeTopMasterKey: number) => {
        if (this.isActiveTopMasterKey) {
          this.isActiveTopMasterKey = false
          // this.saveIsActiveTopMasterKey()

          this.handleDealerError({
            error: {
              message:
                'Active TMK has already been set. By changing this, the construction key bitting will also update.',
            },
          })
        }

        this.isActiveTopMasterKey = this.hierarchyItem.id === activeTopMasterKey

        if (this.isActiveTopMasterKey) {
          // this.saveIsActiveTopMasterKey()
        }
      })

    this.dealerMasterKeyService.getDealerSpecFormData().subscribe((res) => {
      this.dealerSpecs = res
      if (res.length === 0) {
        this.keySectionLocallyModified = false
      }
    })

    this.dealerMasterKeyService.getDealerSpecSaveAndContinueFormData().subscribe((res) => {
      this.saveAndContinueFormData = res
    })

    this.dealerMasterKeyService.keySectionPropagation$
      .pipe(
        filter((propagation) => !!propagation && propagation.masterKeyIds.includes(this.hierarchyItem.id)),
        takeUntil(this.destroy$)
      )
      .subscribe((propagation) => {
        this.keySectionLocallyModified = true
        this.form.patchValue({ keySection: propagation.keySection, keySectionId: propagation.keySectionId })
        this.setDealerSpecFormData()
      })

    this.form.controls.keySection.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      const value = this.form.controls.keySection.value
      if (typeof value !== 'string') return
      const searchString = value.toUpperCase()
      this.childKeySections = this.keySections.filter((keySection) => keySection.name.includes(searchString))
    })

    this.initialLoad = false
  }

  /* istanbul ignore next */
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  /* istanbul ignore next */
  ngOnChanges(changes: SimpleChanges) {
    if (this.structure && this.hierarchyItem && this.keySystem) {
      this.setKeySection()
      this.setMasterKeyBitting()
      this.setIsActiveTopMasterKey()
      this.setFormFields()
      this.setSaveAndContinueFormData()
    }
  }

  onChange(event, inputName: string, trigger?: MatAutocompleteTrigger) {
    if (inputName === 'masterKeyBitting') {
      if (event.key === 'ArrowDown' || event.key === 'Enter') {
        event.preventDefault()
        const currentInput = event.target as HTMLElement
        const allInputs = Array.from(document.querySelectorAll('input[formControlName="masterKeyBitting"]'))

        const currentIndex = allInputs.findIndex((input) => input === currentInput)
        if (currentIndex >= 0) {
          const nextIndex = currentIndex + 1

          if (nextIndex < allInputs.length) {
            const nextInput = allInputs[nextIndex] as HTMLElement
            nextInput.focus()
          }
        }
      } else if (event.key === 'ArrowUp') {
        event.preventDefault()
        const currentInput = event.target as HTMLElement
        const allInputs = Array.from(document.querySelectorAll('input[formControlName="masterKeyBitting"]'))

        const currentIndex = allInputs.findIndex((input) => input === currentInput)
        if (currentIndex > 0) {
          const nextIndex = currentIndex - 1

          if (nextIndex < allInputs.length) {
            const nextInput = allInputs[nextIndex] as HTMLElement
            nextInput.focus()
          }
        }
      }
    }

    if (inputName === 'keySection') {
      if (event.key === 'Enter') {
        event.preventDefault()
        if (trigger) {
          trigger.closePanel()
        }
        this.resolveAndApplyKeySection(event.target.value)
        ;(event.target as HTMLInputElement).blur()

        const currentInput = event.target as HTMLElement
        const allInputs = Array.from(document.querySelectorAll('input[formControlName="keySection"]'))
        const currentIndex = allInputs.findIndex((input) => input === currentInput)
        if (currentIndex >= 0 && currentIndex + 1 < allInputs.length) {
          ;(allInputs[currentIndex + 1] as HTMLElement).focus()
        }
      }
      if (event.key === 'Backspace') {
        this.form.controls.keySection.setValue(null)
        this.form.controls.keySectionId.setValue(null)
        this.setDealerSpecFormData()
      }
    }
  }

  /* istanbul ignore next */
  onKeySectionBlur(event: FocusEvent) {
    const typedValue = (event.target as HTMLInputElement).value
    this.resolveAndApplyKeySection(typedValue)
  }

  disableField(masterKey: MasterKey): boolean {
    let disable = false

    if (!masterKey.parent) {
      disable = true
    } else if (masterKey.disableTMKToggling) {
      disable = true
    }
    return disable
  }

  showField(masterKey: MasterKey): boolean {
    return masterKey.masterKeyTypeId !== 1
  }

  /* istanbul ignore next */
  setActiveTopMasterKey(hierarchyItem, event: MatSlideToggleChange) {
    // this.activeTopMasterKeyService.setActiveTopMasterKey(event.checked ? this.hierarchyItem.id : null)
    this.isActiveTopMasterKey = event.checked
    this.setFormFields()
    this.setDealerSpecFormData()
  }

  /* istanbul ignore next */
  loadKeyways(hierarchyItem) {
    if (this.structure.combinatingRuleSetId === 5) {
      this.childKeySections = this.keySections.filter((kwy) => kwy.keywayTypeId !== KeywayType.Plug)
      this.childKeySections = this.childKeySections.filter((kwy) => kwy.name !== 'C1' && kwy.name !== 'CS')
    } else if (this.structure.combinatingRuleSetId === 8) {
      this.childKeySections = []
      const C1 = this.keySections.find((kwy) => kwy.name === 'C1')
      if (C1) {
        this.childKeySections.push(C1)
      }
      const CS = this.keySections.find((kwy) => kwy.name === 'CS')
      if (CS) {
        this.childKeySections.push(CS)
      }
    } else {
      this.childKeySections = this.keySections.filter((kwy) => kwy.keywayTypeId !== KeywayType.Plug)
    }
  }

  /* istanbul ignore next */
  getKeyways(keywayFamilyId: number, keywayId: number, masterKeyTypeId: number) {
    this.keywayService
      .getKeyways(keywayFamilyId, keywayId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((keyway: Keyway) => {
        this.childKeySections = []
        if (keyway?.childKeyways) {
          this.childKeySections = keyway?.childKeyways
          this.childKeySections.push(keyway)
          this.childKeySections = this.childKeySections.filter((cks) => cks.keywayTypeId !== KeywayType.Plug)
          this.childKeySections.sort((a, b) => (a.name > b.name ? 1 : -1))
          this.filterKeySectionsForSkdAndDirectChangeMasters(masterKeyTypeId)
        }
      })
  }

  /* istanbul ignore next */
  private filterKeySectionsForSkdAndDirectChangeMasters(masterKeyTypeId: number) {
    if (masterKeyTypeId === 5 || masterKeyTypeId === 7) {
      this.childKeySections = this.childKeySections?.filter((kwy) => kwy.keywayTypeId === KeywayType.PlugOrCylinder)
    }
  }

  /* istanbul ignore next */
  setKeySection() {
    if (this.keySectionLocallyModified) return
    if (this.keySections && this.keySections.length > 0 && this.dealerMasterKeys && this.dealerMasterKeys.length > 0) {
      let dealerMasterKey = this.dealerMasterKeys.find((x) => x.masterKeyId == this.hierarchyItem.id)
      if (dealerMasterKey && dealerMasterKey.keySectionId) {
        const keyway = this.keySections.filter((keyway) => keyway.id === dealerMasterKey.keySectionId)[0]
        // this.hierarchyItem.keyway = keyway
        this.form.patchValue({ keySection: keyway })
        this.form.patchValue({ keySectionId: keyway.id })
        return
      }

      if (this.hierarchyItem.keywayId) {
        const keySection = this.keySections.filter((keyway) => keyway.id === this.hierarchyItem.keywayId)[0]
        // this.hierarchyItem.keyway = keySection
        this.form.patchValue({ keySection: keySection })
        this.form.patchValue({ keySectionId: keySection.id })
        return
      }
    }
  }

  /* istanbul ignore next */
  setMasterKeyBitting() {
    if (this.dealerMasterKeys && this.dealerMasterKeys.length > 0) {
      const dealerMasterKey = this.dealerMasterKeys.find((x) => x.masterKeyId == this.hierarchyItem.id)

      if (dealerMasterKey && dealerMasterKey.masterKeyBitting) {
        // this.masterKeyBitting = dealerMasterKey.masterKeyBitting
        this.form.patchValue({ masterKeyBitting: dealerMasterKey.masterKeyBitting })
      }
    }
  }

  /* istanbul ignore next */
  setIsActiveTopMasterKey() {
    const dealerMasterKey = this.dealerMasterKeys.find((x) => x.masterKeyId == this.hierarchyItem.id)
    this.isActiveTopMasterKey = dealerMasterKey?.isActiveTmk ?? false
  }

  /* istanbul ignore next */
  displayFn(keyway: Keyway): string {
    return keyway && keyway.name ? keyway.name : ''
  }

  /* istanbul ignore next */
  hasMinimize(masterKey: MasterKey) {
    return (
      !masterKey.isChangeKey &&
      masterKey?.children?.length &&
      (masterKey.children.length !== masterKey.changeKeys.length || this.showChangeKeys)
    )
  }

  /* istanbul ignore next */
  setFormFields() {
    this.form.patchValue({ keySystemId: this.keySystem.id })
    this.form.patchValue({ masterKeyId: this.hierarchyItem.id })
    this.form.patchValue({ isActiveTmk: this.isActiveTopMasterKey })
  }

  /* istanbul ignore next */
  saveKeySection(keySection: Keyway, event: any) {
    if (event.isUserInput) {
      this.applyKeySection(keySection)
    }
    // this.setFormFields()
  }

  /* istanbul ignore next */
  private resolveAndApplyKeySection(typedValue: string) {
    if (!typedValue || !this.childKeySections?.length) return
    const upper = typedValue.toUpperCase()
    const match =
      this.childKeySections.find((ks) => ks.name.toUpperCase() === upper) ||
      (this.childKeySections.length === 1 ? this.childKeySections[0] : null)
    if (match) {
      this.applyKeySection(match)
    }
  }

  /* istanbul ignore next */
  private applyKeySection(keySection: Keyway) {
    this.keySectionLocallyModified = true
    this.form.patchValue({ keySection, keySectionId: keySection.id })
    this.setDealerSpecFormData()

    if (keySection.keywayTypeId === KeywayType.PlugOrCylinder) {
      const descendantIds = this.getDescendantIds(this.hierarchyItem)
      if (descendantIds.length > 0) {
        this.dealerMasterKeyService.propagateKeySection(descendantIds, keySection, keySection.id)
      }
    }
  }

  /* istanbul ignore next */
  private getDescendantIds(item): number[] {
    if (!item.children || item.children.length === 0) return []
    const ids: number[] = []
    for (const child of item.children) {
      ids.push(child.id)
      ids.push(...this.getDescendantIds(child))
    }
    return ids
  }

  /* istanbul ignore next */
  setSaveAndContinueFormData() {
    let dealerInformation = {
      keySystemId: this.form.controls.keySystemId.value,
      masterKeyId: this.form.controls.masterKeyId.value,
      keySectionId: this.form.controls.keySectionId.value,
      masterKeyBitting: this.form.controls.masterKeyBitting.value,
      isActiveTmk: this.form.controls.isActiveTmk.value,
      formValid: this.form.valid,
      element: this.inputRefs?.toArray()[0],
    }
    //See if the edited master key already exists in the array
    this.saveAndContinueFormData = this.findAndReplace(this.saveAndContinueFormData, 'masterKeyId', dealerInformation)

    this.dealerMasterKeyService.setDealerSpecSaveAndContinueFormData(this.saveAndContinueFormData)
    // if (this.inputRefs && this.inputRefs.length > 0) {
    //   let dealerInformation = {
    //     keySystemId: this.form.controls.keySystemId.value,
    //     masterKeyId: this.form.controls.masterKeyId.value,
    //     keySectionId: this.form.controls.keySectionId.value,
    //     masterKeyBitting: this.form.controls.masterKeyBitting.value,
    //     isActiveTmk: this.form.controls.isActiveTmk.value,
    //     formValid: this.form.valid,
    //     element: this.inputRefs.toArray()[0],
    //   }
    //   //See if the edited master key already exists in the array
    //   this.saveAndContinueFormData = this.findAndReplace(this.saveAndContinueFormData, 'masterKeyId', dealerInformation)

    //   this.dealerMasterKeyService.setDealerSpecSaveAndContinueFormData(this.saveAndContinueFormData)
    // } else {
    //   let dealerInformation = {
    //     keySystemId: this.form.controls.keySystemId.value,
    //     masterKeyId: this.form.controls.masterKeyId.value,
    //     keySectionId: this.form.controls.keySectionId.value,
    //     masterKeyBitting: this.form.controls.masterKeyBitting.value,
    //     isActiveTmk: this.form.controls.isActiveTmk.value,
    //     formValid: this.form.valid,
    //   }
    //   //See if the edited master key already exists in the array
    //   this.saveAndContinueFormData = this.findAndReplace(this.saveAndContinueFormData, 'masterKeyId', dealerInformation)

    //   this.dealerMasterKeyService.setDealerSpecSaveAndContinueFormData(this.saveAndContinueFormData)
    // }
  }

  /* istanbul ignore next */
  setDealerSpecFormData() {
    let dealerInformation = {
      keySystemId: this.form.controls.keySystemId.value,
      masterKeyId: this.form.controls.masterKeyId.value,
      keySectionId: this.form.controls.keySectionId.value,
      masterKeyBitting: this.form.controls.masterKeyBitting.value,
      isActiveTmk: this.form.controls.isActiveTmk.value,
      formValid: this.form.valid,
    }

    //See if the edited master key already exists in the array
    // this.dealerSpecs = this.findAndReplace(this.dealerSpecs, 'masterKeyId', dealerInformation)
    this.dealerSpecs = this.findAndReplace(this.dealerSpecs, 'masterKeyId', dealerInformation)

    this.setSaveAndContinueFormData()
    this.dealerMasterKeyService.setDealerSpecFormData(this.dealerSpecs)
  }

  //check the existing array for the item being added
  //if it exists, replace it
  //if it doesn't exist, add it
  //this will allow us to keep the latest value for each master key
  findAndReplace(array: any[], key: string, value: any): any[] {
    const index = array.findIndex((item) => item[key] === value[key])
    if (index !== -1) {
      array[index] = value
    } else {
      array.push(value)
    }
    return array
  }

  /* istanbul ignore next */
  saveMasterKeyBitting(event, bitting) {
    const input = event.target
    const value = input.value.replace(/[^0-9]/g, '')
    input.value = value.slice(0, this.maxBittingLength)
    this.form.controls.masterKeyBitting.setValue(value.slice(0, this.maxBittingLength))
    this.form.patchValue({ masterKeyBitting: bitting })
    this.setFormFields()
    this.setDealerSpecFormData()
  }

  /* istanbul ignore next */
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter']

    if (!allowedKeys.includes(event.key) && !/^[0-9]$/.test(event.key)) {
      event.preventDefault()
    }
  }

  /* istanbul ignore next */
  handleDealerError(error: any) {
    this.dealererror.emit(error)
  }
}
